module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "info"
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "info-table",
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "info-name"
  }, [_vm._v(" \n\t\t\t\t" + _vm._s(_vm.info.name) + "  \n\t\t\t\t"), (_vm.isFavorite) ? _c('div', {
    staticClass: "like-icon",
    on: {
      "click": function($event) {
        return _vm.removeFavorite()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/ic_like_red.png")
    }
  })]) : _c('div', {
    staticClass: "like-icon",
    on: {
      "click": function($event) {
        return _vm.addFavorite()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/ic_like_grey.png")
    }
  })]), _vm._v(" "), (_vm.info.course_type === 1) ? _c('div', {
    staticClass: "infoCompulsory"
  }, [_vm._v("必修")]) : _vm._e(), _vm._v(" "), (_vm.info.course_type === 0) ? _c('div', {
    staticClass: "infoElective"
  }, [_vm._v("選修")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-description"
  }, [_vm._v(" " + _vm._s(_vm.info.description) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "info-data"
  }, _vm._l((_vm.info.titles), function(title, index) {
    return _c('div', {
      key: index,
      staticClass: "info-title"
    }, [_vm._v(" " + _vm._s(title) + " \n\t\t\t\t\t"), (index === 6) ? _c('div', {
      staticClass: "info-item"
    }, [_c('el-button', {
      staticClass: "author-item",
      attrs: {
        "type": "text"
      },
      on: {
        "click": _vm.clickAuthor
      }
    }, [_vm._v(" " + _vm._s(_vm.info.items[index]) + " ")])], 1) : _c('div', {
      staticClass: "info-item"
    }, [_vm._v(" " + _vm._s(_vm.info.items[index]) + " ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "info-comment"
  }, [(_vm.myComment) ? _c('div', {
    staticClass: "info-my-comment"
  }, [_c('span', {
    staticClass: "comment-title"
  }, [_vm._v("我的評價")]), _vm._v(" "), _c('div', {
    staticClass: "my-info",
    attrs: {
      "id": _vm.myComment.id
    }
  }, [_c('div', {
    staticClass: "my-comment"
  }, [_c('span', {
    staticClass: "my-userinfo"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": require("../../assets/icon/ic_user_2.png"),
      "alt": "U"
    }
  }), _vm._v(" "), (_vm.myComment.anonymous === 0) ? _c('span', {
    staticClass: "user-name"
  }, [_vm._v(" " + _vm._s(_vm.myComment.author.username + ' (' + _vm.myComment.author.displayname + ')'))]) : _c('span', {
    staticClass: "user-name"
  }, [_vm._v(" 匿名 ")]), _vm._v(" "), _c('img', {
    staticClass: "edit-icon",
    attrs: {
      "src": require("../../assets/icon/ic_edit.png"),
      "alt": "E",
      "title": "編輯評價"
    },
    on: {
      "click": function($event) {
        return _vm.commentControl(true, _vm.myComment, 1)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.isSystemAdminMode),
      expression: "$store.state.isSystemAdminMode"
    }],
    staticClass: "delete-icon",
    attrs: {
      "src": require("../../assets/icon/ic_delete.png"),
      "alt": "D",
      "title": "刪除評價"
    },
    on: {
      "click": function($event) {
        return _vm.myCommentDelete(_vm.myComment)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-star-date"
  }, [_c('StarRating', {
    staticClass: "my-star",
    attrs: {
      "rating": _vm.myComment.rating,
      "show-rating": false,
      "max-rating": 5,
      "star-size": 16,
      "read-only": true,
      "increment": 1
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "my-date"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.formatCtime(_vm.myComment.ctime)) + "\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "my-message"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.myComment.comment) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.myComment.reply.content),
      expression: "myComment.reply.content"
    }],
    staticClass: "my-comment-reply"
  }, [_c('span', {
    staticClass: "reply-row"
  }, [_c('span', {
    staticClass: "reply-title"
  }, [_vm._v("作者回覆")]), _vm._v(" "), _c('span', {
    staticClass: "reply-date"
  }, [_vm._v(" " + _vm._s(_vm.formatCtime(_vm.myComment.reply.mtime)) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "reply-message"
  }, [_vm._v(" " + _vm._s(_vm.myComment.reply.content) + " ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRatingTable),
      expression: "showRatingTable"
    }],
    staticClass: "info-rating"
  }, [_c('div', {
    staticClass: "info-rating-score"
  }, [_c('div', {
    staticClass: "info-score"
  }, [_vm._v(_vm._s(_vm.info.aveRating))]), _vm._v(" "), _c('StarRating', {
    staticClass: "info-star",
    attrs: {
      "rating": _vm.info.aveRating,
      "show-rating": false,
      "max-rating": 5,
      "star-size": 17,
      "read-only": true,
      "increment": 0.1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-total-score"
  }, [_vm._v(_vm._s('共' + _vm.info.totalRating + "個評分"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "info-rating-bar"
  }, [_c('div', {
    staticClass: "row-bar",
    attrs: {
      "title": _vm.info.ratingBar[0]
    }
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "right-bar"
  }, [_c('div', {
    staticClass: "bar-container"
  }, [_c('div', {
    staticClass: "bar-5",
    staticStyle: {
      "width": "0%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bar",
    attrs: {
      "title": _vm.info.ratingBar[1]
    }
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "right-bar"
  }, [_c('div', {
    staticClass: "bar-container"
  }, [_c('div', {
    staticClass: "bar-4",
    staticStyle: {
      "width": "0%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bar",
    attrs: {
      "title": _vm.info.ratingBar[2]
    }
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "right-bar"
  }, [_c('div', {
    staticClass: "bar-container"
  }, [_c('div', {
    staticClass: "bar-3",
    staticStyle: {
      "width": "0%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bar",
    attrs: {
      "title": _vm.info.ratingBar[3]
    }
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "right-bar"
  }, [_c('div', {
    staticClass: "bar-container"
  }, [_c('div', {
    staticClass: "bar-2",
    staticStyle: {
      "width": "0%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bar",
    attrs: {
      "title": _vm.info.ratingBar[4]
    }
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "right-bar"
  }, [_c('div', {
    staticClass: "bar-container"
  }, [_c('div', {
    staticClass: "bar-1",
    staticStyle: {
      "width": "0%"
    }
  })])])])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.myComment),
      expression: "!myComment"
    }],
    staticClass: "comment-btn",
    on: {
      "click": function($event) {
        return _vm.commentControl(true)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/ic_edit.png"),
      "alt": "W"
    }
  }), _vm._v(" 撰寫評價\n\t\t\t\t")]), _vm._v(" "), (_vm.commentWindow.display) ? _c('comment', {
    attrs: {
      "resourceId": _vm.info.id,
      "name": _vm.commentWindow.user,
      "rating": _vm.commentWindow.rating,
      "date": _vm.commentWindow.date,
      "content": _vm.commentWindow.content,
      "reply": _vm.commentWindow.reply,
      "anonymous": _vm.commentWindow.anonymous,
      "status": _vm.commentWindow.status,
      "id": _vm.commentWindow.id
    },
    on: {
      "close": function($event) {
        return _vm.commentControl(false)
      },
      "reply": _vm.replyComment,
      "release": _vm.releaseComment,
      "change": _vm.changeComment
    }
  }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.commentList), function(comment, index) {
    return _c('div', {
      key: index,
      staticClass: "other-info",
      attrs: {
        "id": comment.id
      }
    }, [_c('span', {
      staticClass: "other-userinfo"
    }, [_c('img', {
      staticClass: "user-img",
      attrs: {
        "src": require("../../assets/icon/ic_user_2.png"),
        "alt": "U"
      }
    }), _vm._v(" "), (comment.anonymous === 0) ? _c('span', {
      staticClass: "user-name"
    }, [_vm._v(" " + _vm._s(comment.author.username + ' (' + comment.author.displayname + ')') + " ")]) : _c('span', {
      staticClass: "user-name"
    }, [_vm._v(" 匿名 ")]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAuthor && !comment.reply.content),
        expression: "isAuthor && !comment.reply.content"
      }],
      staticClass: "reply-btn",
      on: {
        "click": function($event) {
          return _vm.commentControl(true, comment, 2)
        }
      }
    }, [_vm._v("回覆")]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAuthor && comment.reply.content),
        expression: "isAuthor && comment.reply.content"
      }],
      staticClass: "change-reply-btn",
      on: {
        "click": function($event) {
          return _vm.commentControl(true, comment, 2)
        }
      }
    }, [_vm._v("修改回覆")]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.isSystemAdminMode),
        expression: "$store.state.isSystemAdminMode"
      }],
      staticClass: "delete-icon",
      attrs: {
        "src": require("../../assets/icon/ic_delete.png"),
        "alt": "D",
        "title": "刪除評價"
      },
      on: {
        "click": function($event) {
          return _vm.otherCommentDelete(comment)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "other-star-date"
    }, [_c('StarRating', {
      staticClass: "other-star",
      attrs: {
        "rating": comment.rating,
        "show-rating": false,
        "max-rating": 5,
        "star-size": 16,
        "read-only": true,
        "increment": 1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "other-date"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.formatCtime(comment.mtime)) + "\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
      staticClass: "other-comment"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(comment.comment) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comment.reply.content),
        expression: "comment.reply.content"
      }],
      staticClass: "other-reply-comment"
    }, [_c('span', {
      staticClass: "reply-row"
    }, [_c('span', {
      staticClass: "reply-title"
    }, [_vm._v("作者回覆")]), _vm._v(" "), _c('span', {
      staticClass: "reply-date"
    }, [_vm._v(" " + _vm._s(_vm.formatCtime(comment.reply.mtime)) + " ")])]), _vm._v(" "), _c('span', {
      staticClass: "reply-message"
    }, [_vm._v(" " + _vm._s(comment.reply.content) + " ")])])])
  }), 0)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "info-card-title"
  }, [_vm._v("檔案瀏覽")]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "info-card-column"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.type === 'doc'),
        expression: "file.type === 'doc'"
      }],
      staticClass: "info-card-icon",
      attrs: {
        "src": require("../../assets/icon/ic_document.png"),
        "alt": "C"
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.type === 'video'),
        expression: "file.type === 'video'"
      }],
      staticClass: "info-card-icon",
      attrs: {
        "src": require("../../assets/icon/ic_video.png"),
        "alt": "V"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "info-card-file",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.onlineView(file)
        }
      }
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.backendMode),
        expression: "backendMode"
      }],
      staticClass: "tooltip",
      on: {
        "click": function($event) {
          return _vm.download(file)
        }
      }
    }, [_c('img', {
      staticClass: "info-download-icon",
      attrs: {
        "src": require("../../assets/icon/ic_download.png"),
        "alt": "D"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tooltiptext"
    }, [_vm._v("下載附件")])])])
  })], 2)]), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.info),
      expression: "hint.display && this.$store.state.hintStatus.info"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1), _vm._v(" "), (_vm.showAddFavorite) ? _c('div', {
    ref: "addFavoriteDiv",
    staticClass: "centered add-favorite-message"
  }, [_vm._v(" \n\t\t已加入我的最愛 "), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/icon/ic_like_red.png")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f560e0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Info.vue
// module id = 931
// module chunks = 170